import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { Modal, ThemeService, LanguageService } from '@ui-lib';

@Component({
  imports: [RouterModule, TranslocoModule, Modal],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  // Services loaded on app initialization
  private readonly themeService = inject(ThemeService);
  private readonly languageService = inject(LanguageService);
}
